module.exports = __webpack_public_path__ + "img/15_2.6e68fe79.png";